const actionTypeIdentifier = 'C165E9CB-161C-471B-B2BE-C059146E503C';

export const getDebitorCatalogueUploadTypes = `GET-DEBITOR-CATALOGUE-UPLOAD-TYPES-${actionTypeIdentifier}`;
export const setDebitorCatalgueUploadError = `SET-DEBITOR-CATALOGUE-UPLOAD-ERROR-${actionTypeIdentifier}`;

export const DeitorCatalogueUploadModel = {
    debitorCatalogueUploadTypeId: 0,
    files: []
}